<template>
  <div class="h-dialogContainer">
    <form id='updateNeFF'>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>       
         <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.neDev')}}:</div>
          <ejs-dropdownlist
             name="neDev"
            :placeholder="neDevPlaceholder"
            :dataSource="neDev"
            v-model="neinfo.equipmentId"
            :fields="neDevFields"
            :readonly="readNeDev"
            :noRecordsTemplate="noRecordsTemplate"
          ></ejs-dropdownlist>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.neType')}}:</div>
          <ejs-dropdownlist
             name="neType"
            :placeholder="neTypePlaceholder"
            :dataSource="typeData"
            v-model="neinfo.typeCode"
            :fields="typeFields"
            :readonly="readNeType"
            :noRecordsTemplate="noRecordsTemplate"
          ></ejs-dropdownlist>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit">{{this.$t('Topo.neName')}}:</div>
          <input
            name="neName"
            class="e-input"
            :placeholder="neNamePlaceholder"
            type="text"
            v-model="neinfo.name"
          />
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.cummunicateIPPort')}}:</div>
          <ejs-dropdownlist
             name="equipmentIPId"
            :placeholder="cummunicateIPPortPlaceholder"
            :dataSource="neIPPort"
            v-model="neinfo.equipmentIPId"
            :fields="ipPortFields"
            :noRecordsTemplate="noRecordsTemplate"
          ></ejs-dropdownlist>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.physicalIP')}}:</div>
            <input
              name="neIP"
              class="e-input"
             :placeholder="neIPPlaceholder"
              v-model="neinfo.physicalIP"
            />
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.physicalPort')}}:</div>
          <input
            name="nePort"
            class="e-input"
            :placeholder="nePortPlaceholder"
            type="text"
            v-model="neinfo.physicalPort"
          />
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="h-col-inputBox-a">
        <div class="h-inputLit">{{this.$t('Topo.neDescription')}}:</div>
        <ejs-textbox  name="neDescription" :placeholder="neDescriptionPlaceholder" v-model="neinfo.description" multiline="true"></ejs-textbox>
      </div>
    </div>
    <div class="h-clear-rowMg"></div>
    </form>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import { EventBus } from '../../plugins/eventBus';

export default {
  name: 'update-ne',
  data() {
    return {
      neNamePlaceholder: this.$t('Topo.neName'),
      neTypePlaceholder: this.$t('Topo.devAttriSelect'),
      neDevPlaceholder: this.$t('Topo.neDev'),
      neDescriptionPlaceholder: this.$t('Topo.neDescription'),
      neIPPlaceholder:this.$t('Topo.physicalIP'),
      nePortPlaceholder: this.$t('Topo.physicalPort'),
      cummunicateIPPortPlaceholder: this.$t('Topo.devAttriSelect'),
      noRecordsTemplate: this.$t('Topo.noData'),
      neinfo: {
        id: '',
        name: '',
        typeCode: '',
        positionX: 0,
        positionY: 0,
        equipmentId:'',
        equipmentIPId: '',
        physicalIP: '',     
        physicalPort: '',
        description: ''
      },
      typeData: [], // 网元类型
      neDev: [], // 归属设备
      neIPPort: [], // 通信IP和端口
      typeFields: { value: 'typeCode', text: 'nameKey' },
      neDevFields: { value: 'equipmentId', text: 'equipmentName' },
      ipPortFields: { value:'equipmentIPId', text: 'ipportIPPort' },
      readNeType: true,
      readNeDev:true,
      validationOption: {
        customPlacement(inputElement, errorElement) {
            errorElement.style.float = 'left';
            inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {                    
            neType: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            neName: {
                required: [true, `${this.$t('Pm.alertRequired')}`],
                regex: [/^(^\S)/, `${this.$t('Topo.noEmptyStart')}`],
                maxLength: [30, `${this.$t('Topo.topoMaxLength')}30`],
            },
            neDev: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            equipmentIPId: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            neIP: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
                // maxLength: [255, `${this.$t('Pm.alertMaxLength')}255`],
                regex: [/^(25[0-5]|2[0-4]\d|[0-1]?\d?\d)(\.(25[0-5]|2[0-4]\d|[0-1]?\d?\d)){3}$/, `${this.$t('Topo.ipIllegal')}`]
            },
            nePort: { 
                required: [true, `${this.$t('Pm.alertRequired')}`],
                regex: ['^\\d*$', `${this.$t('Topo.invalidInt')}`],
                range: [[1, 65535], `${this.$t('Topo.inputRangeIllegal')}`],               
            },
            neDescription: {            
                maxLength: [255, `${this.$t('Topo.topoMaxLength')}255`],
            },
        }
    }, 
    };
  },
  mounted() {
    this.initData();
    this.bindValidate();
  },
  methods: {
    outputs(isFromGraph) {
      //表单验证
      if(!this.validate()){
          return;
      }
      if (isFromGraph) {
        this.neinfo.positionX = positionX;
        this.neinfo.positionY = positionY;
      }
      const params = {
        ...this.neinfo,
        typeCode: this.neinfo.typeCode.toString(),
      };
      // 修改网元
      this.axios.post('/lte/ems/topo/ne/modifyNe', params).then((response) => {
        if(response.data === undefined){
          return;
        }
        if( response.status ===200){
          if (response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
            this.closeWindow();
            return;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
        this.closeWindow();
      });
    },
   
       // 新建网元时去后台查已经创建的设备
    queryAttriDevice() {
      const This = this;
      This.$axios.get('/lte/ems/topo/ne/attriDevice').then(response => {  
        console.log('attriDevice',response)    
        if(response.data === undefined){
          return;
        }
        if( response.status ===200){
        if (response.data.errorCode === 'SUCCESS') {
          const neDevTemp=[];
          const len=response.data.resultVal.result.length;
          for(var i=0;i<len;i++){
            neDevTemp.push({
                equipmentId:response.data.resultVal.result[i].id,
                equipmentName:response.data.resultVal.result[i].name
              }) 
          }
          This.neDev = neDevTemp; 
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        } }    
      });
    },
    //切换归属设备时查能添加的网元类型
    onAttriDeviceChange(e,resolve) {     
      const attriDevId = parseInt(e);
      const This = this;
      const neTypeTemp=[];
      This.$axios.get(`/lte/ems/topo/ne/findNeType/${attriDevId}`).then(response => {
        if(response.data === undefined){
          return;
        }
        if( response.status ===200){
        if (response.data.errorCode === 'SUCCESS') {
         const neTypeTemp=[];
          const len=response.data.resultVal.length;
          for(var i=0;i<len;i++){    
            neTypeTemp.push({
                typeCode:response.data.resultVal[i].typeCode,
                nameKey:response.data.resultVal[i].nameKey
            }) 
          }
          This.typeData = neTypeTemp;  
          resolve(); 
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        } }     
      });
    },

    queryDevIpPort(e,resolve) {
      const devID = parseInt(e);
      const This = this;
      const neIPPortTemp=[];
      This.$axios.get(`/lte/ems/topo/ne/findDevIpPort/${devID}`).then(response => {
        if(response.data === undefined){
          return;
        }
        if( response.status ===200){
        if (response.data.errorCode === 'SUCCESS') {
          const len=response.data.resultVal.length;
          for(var i=0;i<len;i++){
            neIPPortTemp.push({
                equipmentIPId:response.data.resultVal[i].id,
                ipportIPPort:response.data.resultVal[i].ip+':'+response.data.resultVal[i].port
              }) 
          }
          This.neIPPort = neIPPortTemp;
          resolve(); 
        } else {
           EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        } }
      });
    },

    closeWindow() {
      console.log('close');
      this.$emit('close');
    },
    initData(nedata) {
    this.neinfo = {
        id: '',
        name: '',
        typeCode: '',
        positionX: 225,
        positionY: 226,
        equipmentId:'',
        equipmentIPId: '',
        physicalIP: '',     
        physicalPort: '',
        description: ''
    };
    if(nedata !== undefined){
    console.log('nedata2', nedata);
    // this.queryAttriDevice();
    const This = this;
    new Promise((resolve) => {
        this.onAttriDeviceChange(nedata.equipmentId,resolve);
    }).then(() => {
       new Promise((resolve) => {
        this.queryDevIpPort(nedata.equipmentId,resolve);
    }).then(() => {
    const neDevTemp = [];
      neDevTemp.push({
      equipmentId:nedata.equipmentId,
      equipmentName:nedata.equipmentName
    }) 
    This.neDev = neDevTemp; 
      console.log('This.neDev',This.neDev) 
        This.neinfo=nedata;
        console.log('neinfo',This.neinfo)
    });
    });
    }   
    },

    bindValidate() {            
      this.formObj = new FormValidator('#updateNeFF', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  }
};
</script>
